import { RetainBehaviorModifier } from '../../../atoms'

/**
 * @description
 * Merges two arrays of Retain Behavior modifiers of the same type.
 * Removes duplicates in the resulting array, and returns that array.
 **/
export const mergeRetainModifiers = (
    modifiersA: RetainBehaviorModifier[],
    modifiersB?: RetainBehaviorModifier[],
): RetainBehaviorModifier[] => {
    if (!modifiersB) {
        return modifiersA
    }
    const mergedModifiers = [...modifiersA, ...modifiersB]
    /** Remove duplicates */
    return mergedModifiers.filter((modifier, index) => mergedModifiers.indexOf(modifier) === index)
}
